import { useMemo } from "react";
import { FormulaDisplay } from "./FormulaDisplay";
import { ParsedExpression } from "@/entities/Finance/models/MetricQueryResponse.model";
import { ParsedMetric } from "./metrics.types";
import { MetricType } from "@/features/Metrics/Metrics.types";

export function ParsedLineageExpression({
    expression,
    metricType = MetricType.CURRENCY,
}: {
    expression: ParsedExpression;
    metricType?: MetricType;
}) {
    const metric: ParsedMetric = useMemo(
        () => ({
            period: expression.period,
            result: expression.result,
            formula: expression.formula,
            values: expression.values.map((v) => ({
                value: v.value ?? 0,
                ref: v.ref,
                meta: v.period
                    ? {
                          period: v.period,
                          accountId: v.accountId ?? "",
                          dataAssetId: v.dataAssetId ?? "",
                          location: v.location ?? "",
                      }
                    : undefined,
            })),
        }),
        [expression],
    );

    return (
        <div className="mt-1 flex flex-col gap-2">
            <FormulaDisplay metric={metric} metricType={metricType} />
        </div>
    );
}
